module.exports = __webpack_public_path__ + "media/site/images/key-features/screenshots/mobile-holiday-work-schedules-30ae8cc826370d39a80c393aad840308.png";